/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import { IndexRoute, Route } from 'react-router';
import {
    App,
    Contact,
    Content,
    Accueil,
    Approche,
    StrategieWeb,
    ServiceConseil,
    DeveloppementWeb,
    Agence,
    Blogue,
    Realisation,
    Realisations,
    NotFoundPage,
    SingleBlogue,
    CategorieBlogue,
} from './containers';

export default (store) => {
    return (
        <Route>
            <Route path="/" component={App}>
                <IndexRoute component={Accueil} />
                <Route path="agence" component={Agence} />
                <Route path="approche" component={Approche} />
                <Route path="strategie-web" component={StrategieWeb} />
                <Route path="service-conseil" component={ServiceConseil} />
                <Route path="developpement-web" component={DeveloppementWeb} />
                <Route path="realisations" component={Realisations} />
                <Route path="blogue" component={Blogue} />
                <Route path="contact" component={Contact} />
                <Route path="realisations/:slug" component={Realisation} />
                <Route path="blogue/:slug" component={SingleBlogue} />
                <Route path="blogue/categorie/:slug" component={CategorieBlogue} />
            </Route>
            <Route path="*" getComponent={NotFoundPage.getComponent} />
        </Route>
    );
};



// WEBPACK FOOTER //
// ./routes.js